import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, ServicesReducer, ServicesState } from "./services-reducer";

const ServicesContext = createContext<ServicesState | undefined>(undefined);
const ServicesContextDispatchContext = createContext({} as any);

const ServicesProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ServicesReducer, { loading: false } as ServicesState);

    return (
        <ServicesContext.Provider value={state}>
            <ServicesContextDispatchContext.Provider value={dispatch}>
                {children}
            </ServicesContextDispatchContext.Provider>
        </ServicesContext.Provider>
    );
}

const useServicesState = () => {
    const context = useContext(ServicesContext);
    if (context === undefined) {
        throw new Error('useServicesState must be used within a ServicesProvider');
    }
    return context;
}

const useServicesDispatch = () => {
    const context = useContext(ServicesContextDispatchContext);
    if (context === undefined) {
        throw new Error('useServicesDispatch must be used within a ServicesProvider');
    }
    return context;
}

export { ServicesProvider, useServicesState, useServicesDispatch, ACTION_TYPES };